export default __webpack_public_path__ + "static/media/autorenew.14163f44.svg";